var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3463",
    "data-name": "Rectangle 3463",
    width: 24,
    height: 24,
    transform: "translate(707 563.485)",
    fill: "#8a8a8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.109,
    y1: 0.085,
    x2: 0.943,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feb31d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb730"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8c218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb21e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_1",
    x: 1.549,
    y: 1.304,
    width: 22.791,
    height: 23.329,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.822,
    dy: 0.822,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.959,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#13062f",
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2106",
    x: 7.571,
    y: 7.637,
    width: 10.462,
    height: 10.103,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.548,
    dy: 0.548,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.548,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_224",
    "data-name": "Mask Group 224",
    transform: "translate(-707 -563.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0633\\u06A9\\u0647",
    transform: "translate(709.949 566.845)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 8.577,
    cy: 8.846,
    rx: 8.577,
    ry: 8.846,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8371",
    "data-name": "Group 8371",
    transform: "translate(0.657 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 8.517,
    cy: 8.786,
    rx: 8.517,
    ry: 8.786,
    transform: "translate(0.001 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3.61, -3.36)",
    filter: "url(#Subtraction_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1-2",
    "data-name": "Subtraction 1",
    d: "M8.517,17.573A8.519,8.519,0,0,1,.648,12.149,8.99,8.99,0,0,1,2.494,2.573a8.334,8.334,0,0,1,12.045,0A8.984,8.984,0,0,1,14.54,15,8.333,8.333,0,0,1,8.517,17.573Zm0-16.108a7.212,7.212,0,0,0-7.1,7.322,7.212,7.212,0,0,0,7.1,7.322,7.212,7.212,0,0,0,7.1-7.322A7.22,7.22,0,0,0,8.517,1.464Z",
    transform: "translate(3.61 3.36)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3.61, -3.36)",
    filter: "url(#Path_2106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2106-2",
    "data-name": "Path 2106",
    d: "M1.988,6.794c1.582.125,3.7-.348,4.677-1.728a2.683,2.683,0,0,0,.467-2.032C6.765.9,3.849-.346.159.085l0,1.73c2.93-.251,5.433.032,5.862,1.492.654,2.213-2.624,2.832-3,2.819a1.784,1.784,0,0,0,.429-1.083A1.728,1.728,0,0,0,0,5.042C0,6.235.952,6.731,1.988,6.794Z",
    transform: "translate(8.67 8.73)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.2c8e142c25e80eb7d8198c68794dcd0d.svg";
export { ForwardRef as ReactComponent };